import { HeaderProgressBar } from "@porchpass/ui";
import { useDealershipData } from "src/hooks";
import { AccountMenu } from "src/components/AccountMenu";
import { PageBackButton } from "src/components/Buttons";
import { DLA_STEP_TOTAL } from "src/constants";

export type PageHeaderProps = {
  /** Wizard section name. Only shown when `stepIndex` is set. */
  stepTitle?: string;
  /** Application wizard step (1–12). Step name and progress bar render only when set. */
  stepIndex?: number;
  /** Renders a back button in the header's left slot. */
  onBackClick?: () => void;
};

export const PageHeader = ({
  stepTitle,
  stepIndex,
  onBackClick,
}: PageHeaderProps = {}) => {
  const dealerData = useDealershipData();
  const showStepProgress = stepIndex != null;
  const progress = showStepProgress
    ? (stepIndex / DLA_STEP_TOTAL) * 100
    : undefined;
  const progressLabel = showStepProgress
    ? `${stepIndex}/${DLA_STEP_TOTAL}`
    : undefined;

  return (
    <header className="sticky top-0 z-40 w-screen shrink-0 bg-white ml-[calc(50%-50vw)]">
      <div
        className={`relative flex items-center justify-end px-6 sm:px-10 ${
          showStepProgress ? "min-h-[72px] py-3" : "min-h-11 py-2.5"
        }`}
      >
        {onBackClick ? (
          <div className="absolute top-1/2 left-6 z-10 -translate-y-1/2 sm:left-10">
            <PageBackButton onClick={onBackClick} />
          </div>
        ) : null}
        <div
          className={`pointer-events-none absolute inset-x-0 flex flex-col items-center px-14 ${
            showStepProgress ? "justify-center py-2" : "justify-center"
          }`}
        >
          <img
            src={dealerData.logoUrl}
            data-replay-safe={true}
            alt={`${dealerData.dealerId} Logo`}
            className="max-h-8 w-auto max-w-[160px] object-contain"
          />
          {showStepProgress && stepTitle ? (
            <p
              className="mt-2 text-center text-[11px] font-medium leading-4 text-[#687082]"
              data-replay-safe
            >
              {stepTitle}
            </p>
          ) : null}
        </div>
        <div className="relative z-10 ml-auto">
          <AccountMenu />
        </div>
      </div>
      {showStepProgress ? (
        <HeaderProgressBar progress={progress} progressLabel={progressLabel} />
      ) : (
        <div className="h-px w-full bg-surface-container-disabled" />
      )}
    </header>
  );
};
